import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { IconType, IconMap, IconDetail } from 'src/app/cxone/dashboard/modules/report/channel-type-cell-renderer/channel-type-cell-renderer.model';

@Component({
    selector: 'cv-channel-cell-renderer',
    templateUrl: './channel-cell-renderer.component.html',
    styleUrls: ['./channel-cell-renderer.component.scss']
})
export class ChannelCellRendererComponent implements AgRendererComponent {
    params: any;
    text = "";
    iconType: IconType;
    iconMap = IconMap;
    iconDetail: IconDetail;

    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.text = this.params.data?.ChannelDisplayName;

        this.iconDetail = {
            iconType: channelTypeToIconMap[this.text.toUpperCase().replace(/ /g, '_')],
        };
    }

    refresh(params: ICellRendererParams): boolean {
        this.params = params;

        return true;
    }

}

export const channelTypeToIconMap: { [key: string]: IconType } = {
    CHAT: IconType.Chat,
    PHONE_CALL: IconType.Voice,
    EMAIL: IconType.Email,
    SMS: IconType.SMS,
    PHONE_CALL_IVR: IconType.IVR,
    FB_PRIVATE: IconType.Facebook_Messenger,
    TW_PRIVATE: IconType.Twitter_Direct_Message,
    WHATSAPP_PRIVATE: IconType.WhatsApp,
    WHATSAPP_PUBLIC: IconType.WhatsApp,
    APPLE_BUSINESS_CHAT_PRIVATE: IconType.Apple_Business_Chat,
    APPLE_BUSINESS_CHAT: IconType.Apple_Business_Chat,
    LINE_PRIVATE: IconType.LINE_Messaging,
    TELEGRAM_PRIVATE: IconType.Telegram_Messenger,
    VIBER_PRIVATE: IconType.Viber_Messenger,
    CUSTOM_PRIVATE: IconType.Custom,
    WORKITEM: IconType.WorkItem,
    GOOGLE_BUSINESS_MESSAGES_PRIVATE: IconType.Google_Business_Messenger,
    SLACK_PRIVATE: IconType.Slack,
    SLACK: IconType.Slack,
    SLACK_PUBLIC: IconType.Slack,
    MICROSOFT_TEAMS_PRIVATE: IconType.Microsoft_Teams,
    FB_PUBLIC: IconType.Facebook_Public,
    FACEBOOK_PUBLIC: IconType.Facebook_Public,
    TW_PUBLIC: IconType.Twitter_Public,
    TWITTER_PUBLIC: IconType.Twitter_Public,
    YT_PUBLIC: IconType.YouTube_Public,
    LI_PUBLIC: IconType.LinkedIn_Public,
    APPLE_APPS_REVIEWS_PUBLIC: IconType.Apple_Apps_Reviews_Public,
    GOOGLE_PLACES_PUBLIC: IconType.Google_Places_Public,
    GOOGLE_PLAY_PUBLIC: IconType.Google_Play_Public,
    CUSTOM_PUBLIC: IconType.Custom_Public,
    'CUSTOM-PRIVATE': IconType.Custom,
    DESKTOP_ACTIVITY: IconType.Desktop_Activity,
    FORUM_DM: IconType.Forum,
    KIK: IconType.Kik,
    KIK_PUBLIC: IconType.Kik,
    FACEBOOK_MESSENGER: IconType.Facebook_Messenger,
    VOICE_MAIL: IconType.Voicemail,
    DIGITAL: IconType.Digital,
    SOCIAL: IconType.Social,
    LIVECHAT_PUBLIC: IconType.LiveChat_Public,
};
